import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarElectricEngines,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import { OptionType } from '@/typings/common';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

function ElectricEnginesFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedElectricEngines =
    useTypedSelector(getSelectedFilters).selectedParams.selectedElectricEngines;

  const electricEnginesOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'electricEngines'
  );

  const handleChangeElectricEngine = (electricEngine: OptionType) => {
    dispatch(
      setCarElectricEngines(
        handleChangeMultiSelect(electricEngine, selectedElectricEngines)
      )
    );
    dispatch(setPage(1));
  };

  const handleClearElectricEngines = () => {
    dispatch(setCarElectricEngines([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Количество электродвигателей"
      options={electricEnginesOptions}
      selectedOptions={selectedElectricEngines}
      onChange={handleChangeElectricEngine}
      onClear={handleClearElectricEngines}
    />
  );
}

export default ElectricEnginesFilter;
